/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/np7zgQo9412LDvi1mA1UmK
 */
export const schema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        row1: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
            },
            default: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
        },
        row2: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
            },
            default: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
        },
        row3: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
            },
            default: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
        },
        row4: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
            },
            default: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
        },
        row5: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
            },
            default: ['xooox', 'xxoxx', 'xoxox', 'oxxxo', 'xxxxx', 'oxoxo', 'ooxoo'],
        },
        rowColor: {
            type: 'array',
            items: {
                type: 'string',
                pattern: '^(transparent|[a-fA-F0-9]{6})$',
            },
            default: [
                'e53935',
                'ffb300',
                '1e88e5',
                '546e7a',
                '6d4c41',
                '00acc1',
                'f4511e',
                '5e35b1',
                '43a047',
                '757575',
                '3949ab',
                '039be5',
                '7cb342',
                'c0ca33',
                'fb8c00',
                'd81b60',
                '8e24aa',
                '00897b',
                'fdd835',
            ],
        },
    },
};
